import { CLEAR_VERIFICATION_STATUS, SET_VERIFICATION_ATTEMPT, verificationStatus } from "../actions/verificationActions";

const initialState = {
    status: verificationStatus.none
}

export default function verificationReducer( state = initialState, action ) {
    switch ( action.type ) {
        case CLEAR_VERIFICATION_STATUS:
            return {
                ...state,
                ...initialState
            };
        case SET_VERIFICATION_ATTEMPT:
            return {
                ...state,
                status: action.status
            };
        default: return state;
    }
}